import { Info } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

export function InfoTip({ text, label = "info" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" aria-label={`What is ${label}?`} data-testid={`infotip-${label}`}
          className="text-slate-400 hover:text-brand transition-colors inline-flex">
          <Info size={13} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 text-xs leading-relaxed text-slate-600 p-3" side="top">
        {text}
      </PopoverContent>
    </Popover>
  );
}
